import { UserRole } from 'shared/types/userRole';
import { PermissionManagerFactory } from '../permissionManagerFactory';
import { PermissionConfig } from '../types';

export const CREATE_CONTRACT_PERMISSIONS: PermissionConfig = {
  [UserRole.superAdmin]: true,
  [UserRole.organizationAdmin]: true,
  [UserRole.projectAdmin]: true,
  [UserRole.manager]: true,
  [UserRole.viewer]: false,
  [UserRole.standard]: false,
  [UserRole.visible_no_access]: false,
};

export const EDIT_CONTRACT_PERMISSIONS: PermissionConfig =
  CREATE_CONTRACT_PERMISSIONS;

export const ContractPermissionManager = PermissionManagerFactory.create({
  permissionConfigForCreate: CREATE_CONTRACT_PERMISSIONS,
  permissionConfigForEdit: EDIT_CONTRACT_PERMISSIONS,
  permissionConfigForDelete: null,
});
